module.exports = __webpack_public_path__ + "assets/d0651ba19a6df1fe24582ea40f23d8a7.png";